!function() {
  var winW = document.documentElement.clientWidth;
  var fontS = 0;

  if (winW > 640) {
    winW = 414;
  }

  fontS = Math.round(winW / 3.75);
  document.documentElement.style.fontSize = fontS + "px";
}();



// WEBPACK FOOTER //
// ./src/utils/autorem.js